<template>
  <div class="register-page">
    <div class="contain-box">
      <div class="header-logo-ban">
        <div>聊城市房地产中介机构监管服务平台</div>
        <div style="font-size: 16px">
          LIAOCHENG REAL ESTATE INTERMEDIARY SUPERVISION SERVICE PLATFORM
        </div>
      </div>
      <div class="sign-in-box">
        <div class="sign-title">个人注册</div>
            <el-form
              ref="personForm"
              :model="personForm"
              :rules="personRules"
              label-width="100px"
            >
              <el-row>
                <el-col :span="12">
                  <el-form-item label="真实姓名" prop="user">
                    <el-input
                      v-model.trim="personForm.user"
                      maxlength="20"
                      placeholder="请输入真实姓名"
                    />
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <el-form-item label="身份证号" prop="idNumber">
                    <el-input
                      v-model.trim="personForm.idNumber"
                      maxlength="18"
                      placeholder="请输入身份证号"
                    />
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <el-form-item label="电话" prop="name">
                    <el-input
                      v-model.trim="personForm.name"
                      maxlength="11"
                      placeholder="请输入电话"
                    />
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="获取验证码"
                    prop="verification"
                    class="phone-number-box"
                  >
                    <el-input
                      v-model="personForm.verification"
                      class="register-verification"
                      type="text"
                      placeholder="请输入手机验证码"
                    />
                    <div
                      v-if="!codeTime"
                      @click="getCode"
                      class="verification-btn"
                    >
                      {{ verBtnStr }}
                    </div>
                    <div
                      v-else
                      class="verification-btn"
                      style="background: #999"
                    >
                      {{ remainingTime }}秒后重试
                    </div>
                  </el-form-item>
                </el-col>
              </el-row> -->
            </el-form>

        <div @click="postRegister" class="submit-btn">注册</div>
      </div>
    </div>
  </div>
</template>

<script>
import { register } from "@/assets/api/common";
export default {
  name: "LogIn",
  data() {
    return {
      personForm: {
        user: "",
        idNumber: "",
        name: "",
        // verification: "",
        registerStatus: '2'
      },
      personRules: {
        user: [{ required: true, message: "请输入真实姓名", trigger: "blur" }],
        idNumber: [{ 
          required: true, 
          message: "请输入正确的身份证号", 
          trigger: "blur" ,
          pattern:/^[1-8][1-7]\d{4}(?:19|20)\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/
        }],
        name: [
          {
            required: true,
            pattern: /^1[0-9]\d{9}$/,
            message: "请输入正确的电话",
            trigger: "blur",
          },
        ],
        // verification: [
        //   { required: true, message: "请输入验证码", trigger: "blur" },
        // ],
      },
      codeTime: false,
      remainingTime: 60,
      verBtnStr: "获取验证码",
    };
  },
  mounted() {},
  methods: {
    postRegister() {
        this.$refs["personForm"].validate((valid) => {
          if (valid) {
            register(this.personForm).then(res=> {
              if (res && res.data.code === 200) {
                this.showToastBtm("注册成功");
                this.$router.push({
                      path: "/logIn", //跳转的路径
                });
              } else {
                this.showToastBtm("服务异常");
              }
            })
          }
        });
    },
    /**
     * 获取验证码
     */
    getCode() {
      if (!/^1[1234567890]\d{9}$/.test(this.personForm.name)) {
        this.showToastBtm("电话号格式不正确，请重新输入");
        return;
      }
      this.verBtnStr = "发送中...";
      setTimeout(() => {
        this.verBtnStr = "获取验证码";
        this.playCodeTime();
      }, 1000);
    },
    /**
     * code倒计时
     */
    playCodeTime() {
      this.codeTime = true;
      this.remainingTime = 60;
      let getCodeTime = setInterval(() => {
        if (this.remainingTime <= 1) {
          clearInterval(getCodeTime);
          this.codeTime = false;
        }
        this.remainingTime--;
      }, 1000);
    },
    /**
     * 用户密码登录
     */
  },
};
</script>

<style lang="less">
.register-page {
  height: 100%;

  .contain-box {
    width: 100%;
    height: 100%;
    background-image: url("../../assets/img/login.jpg");
    background-repeat: no-repeat; //不重复
    background-size: 100% 100%;
    position: fixed;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .header-logo-ban {
      height: auto;
      width: 680px;
      font-size: 34px;
      color: #c3241c;
      font-weight: bold;
      text-shadow: 0 0 0.3em #fff, 0 0 0.3em #fff, 0 0 0.3em #fff;
      text-align: center;
      margin-top: -140px;
      cursor: pointer;
    }

    .sign-in-box {
      margin-top: 42px;
      width: 700px;
      padding: 0 30px;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 8px;

      .sign-title {
        height: 29px;
        line-height: 1;
        color: #000;
        font-size: 18px;
        padding: 40px 0 18px;
        text-align: left;
        box-sizing: content-box;
        position: relative;

        .error-box {
          position: absolute;
          left: 0;
          bottom: 6px;
          color: #ff5600;
          font-size: 12px;
        }
      }

      .log-ipt {
        display: block;
        width: 340px;
        height: 42px;
        margin: 0 auto 20px;
        border: 1px solid rgba(204, 204, 204, 1);
        border-radius: 8px;
        font-size: 14px;
        color: #000000;
        padding: 15px 20px;
        box-sizing: border-box;
      }

      .btn-clr-box {
        text-align: center;
        margin-top: 22px;
        font-size: 16px;
        color: #999999;
        cursor: pointer;
        padding-bottom: 42px;
      }

      .fn-log-box {
        margin-top: 12px;
        height: 18px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #323232;
        font-size: 12px;

        div {
          cursor: pointer;
        }

        .log-message {
          display: flex;
          align-items: center;

          img {
            width: 12px;
            height: auto;
            margin-right: 8px;
            cursor: pointer;
          }
        }
      }

      .submit-btn {
        width: 340px;
        height: 40px;
        margin: 10px auto 40px;
        background: #b1191a;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        font-size: 20px;
        cursor: pointer;
        letter-spacing: 8px;
      }

      .line-box {
        margin-top: 20px;
        height: 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #999999;
        font-size: 12px;

        .line {
          width: 120px;
          height: 1px;
          background: rgba(230, 230, 230, 1);
        }
      }

      .log-bottom-box {
        height: 20px;
        margin-top: 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .out-log-fn {
          display: flex;
          align-items: center;

          img {
            width: 20px;
            height: 20px;
            margin-right: 8px;
            cursor: pointer;
          }

          span {
            color: #323232;
            font-size: 12px;
            cursor: pointer;
          }

          .s-line {
            height: 18px;
            width: 1px;
            margin: 0 9px;
            background: #323232;
          }
        }

        .register-go {
          display: flex;
          align-items: center;
          color: #e10101;
          font-size: 16px;
          cursor: pointer;
          margin-top: 20px;

          img {
            width: 18px;
            height: 18px;
            margin-right: 4px;
          }
        }
      }
    }
  }
  .el-input__inner {
    width: 520px;
  }

  .el-tabs__item {
    line-height: 1;
    height: 28px;
  }
  .el-tabs__nav-wrap::after {
    display: none;
  }
  .el-tabs__item.is-active {
    color: #b1191a;
    &:hover {
      color: #b1191a;
    }
  }
  .el-tabs__item:hover {
    color: #b1191a;
  }
  .el-tabs__active-bar {
    background-color: #b1191a;
  }

  .phone-number-box {
    position: relative;
    width: 100%;
    .el-form-item__content {
      width: 520px;
      line-height: 42px;
    }
    .register-verification {
      display: inline-block;
      width: 240px;
    }

    .el-input__inner {
      display: block;
      width: 240px;
      height: 42px;
      border: 1px solid rgba(204, 204, 204, 1);
      border-radius: 8px;
      font-size: 14px;
      color: #000000;
      padding: 15px 20px;
      box-sizing: border-box;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-right: none;
    }

    .verification-btn {
      width: 100px;
      height: 42px;
      background: #b1191a;
      border-radius: 8px;
      color: #ffffff;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-left: none;
      display: inline-block;
      text-align: center;
    }
  }
}
</style>
